import keys from 'locale/keys';
import React, { Component } from 'react';
import SVG from 'react-inlinesvg';
import { connect } from 'react-redux';
import {
    changeFileUploadStatus,
    removeFromFileUploader,
    resetFileUploadStatus,
    uplaodFile,
} from '../../../store/actions/fileUplaoder';
import { Typography } from 'foundations/typography';
import SVGIcon from 'foundations/icon';
import { noop } from 'utils/constants/common';

const stylePreviewObject = {
    maxHeight: '80%',
    maxWidth: '80%',
};

export const FILE_UPLOAD_STATUS = {
    UPLOADING: 'UPLOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};

const API_MAX_IN_MB = 10;
const BYTES_IN_MB = 1024 * 1024;
const BOOTH_POSTER_REQUEST_KEY = 'boothPosterUrl';
class FileUploader extends Component {
    constructor(props) {
        super(props);
        const size =
            props.size > API_MAX_IN_MB && !props.isPDF
                ? API_MAX_IN_MB
                : props.size;
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onRemoveHandler = this.onRemoveHandler.bind(this);
        this.state = {
            selectedFile: null,
            loaded: props.fileURL ? 1 : -1,
            fileURL: props.fileURL,
            errors: null,
            size: (size || API_MAX_IN_MB) * BYTES_IN_MB,
            uploadSize: null,
            fileName: '',
            showImg: true,
            removeImg: props.existingImg ? true : false,
            preLoadedFileURL: props.existingImg,
            removeImgHandler: props.removeImgHandler || null,
            customError: props.customError || false,
            errorMsg: props.errorMsg || null,
            hasFilter: props.hasFilter || false,
            isSVG: false,
            format: props.formats || [
                'image/png',
                'image/jpeg',
                'image/webp',
                'image/gif',
                'image/svg+xml',
            ],
            removeText: props.removeText || props.t(keys.GENERAL_CLEAR),
            deleteIcon: props.deleteIcon || false,
        };
    }

    componentDidUpdate(oldProps) {
        const { props } = this;
        if (props.fileURL !== oldProps.fileURL) {
            this.setState({
                loaded: 1,
                fileURL: props?.fileURL,
            });
        }
    }

    componentDidMount() {
        const file = this.props.existingImg;
        if (this.state.preLoadedFileURL) {
            let uploadedFormat = file
                .slice(((file.lastIndexOf('.') - 1) >>> 0) + 2)
                .toUpperCase();
            if (uploadedFormat === 'SVG') {
                this.setState({
                    isSVG: true,
                });
            }
        }
        if (this.props.existingImg) {
            this.setState({
                selectedFile: file,
                loaded: 1,
                fileURL: this.props.existingImg,
            });
        }
    }

    componentWillUnmount() {
        const { requestFileId, dispatch } = this.props;
        if (this.state.loaded) {
            dispatch(removeFromFileUploader(requestFileId));
        }
        dispatch(resetFileUploadStatus(requestFileId));
    }
    checkUploadedFiles = (event) => {
        let files = event.target.files;
        let size = this.state.size;
        let err = []; // create empty array
        const types = this.state.format;
        for (let x = 0; x < files.length; x++) {
            let uploadedFormat = files[x].name
                .slice(((files[x].name.lastIndexOf('.') - 1) >>> 0) + 2)
                .toUpperCase();
            if (types.every((type) => files[x].type !== type)) {
                err[x] = uploadedFormat + ' is not a supported format\n';
            }
            if (files[x].size > size) {
                err[x] = 'The uploaded file is over ' + size / 1024 + 'kb\n';
            }
            if (uploadedFormat === 'SVG') {
                this.setState({
                    isSVG: true,
                });
            } else {
                this.setState({
                    isSVG: false,
                });
            }
        }
        if (err.length > 0) {
            event.target.value = null;
            return { status: false, errors: err };
        }

        return { status: true, errors: null };
    };

    onRemoveHandler = () => {
        const {
            dispatch,
            requestFileId,
            defaultImage,
            isImageUploaded,
        } = this.props;
        this.setState({
            showImg: defaultImage || false,
            removeImg: false,
            preLoadedFileURL: '',
            isSVG: false,
        });
        dispatch(removeFromFileUploader(requestFileId));
        if (this.state.removeImgHandler) {
            this.props.removeImgHandler(isImageUploaded, requestFileId);
        }
    };

    onChangeHandler = (event) => {
        const {
            requestFileId,
            dispatch,
            filePrefix,
            existingImg,
            fadeError,
        } = this.props;

        dispatch(
            changeFileUploadStatus(requestFileId, FILE_UPLOAD_STATUS.UPLOADING)
        );
        const uploadStatus = this.checkUploadedFiles(event);
        if (!uploadStatus.status) {
            // dispatch(addToast(uploadStatus.errors[0]));
            this.setState({
                selectedFile: null,
                loaded: 0,
                errors: uploadStatus.errors[0],
            });
            if (this.props.setPicErr) {
                this.props.setPicErr(uploadStatus.errors[0]);
            }
            dispatch(
                changeFileUploadStatus(requestFileId, FILE_UPLOAD_STATUS.ERROR)
            );
            if (fadeError) {
                setTimeout(() => {
                    this.setState({
                        selectedFile: existingImg,
                        loaded: 1,
                        errors: null,
                    });
                    dispatch(
                        changeFileUploadStatus(
                            requestFileId,
                            FILE_UPLOAD_STATUS.SUCCESS
                        )
                    );
                }, 3000);
            }
            return false;
        }
        const file = event.target.files[0];
        this.setState({
            selectedFile: file || existingImg,
            loaded: 0,
            errors: null,
            fileName: file.name,
            uploadSize: (file.size / 1024).toFixed(2) + 'kB',
        });
        if (this.props.removeLogo) {
            this.setState({
                removeImg: true,
                showImg: true,
            });
        }
        this.props.setPicErr && this.props.setPicErr(null);
        dispatch(uplaodFile(requestFileId, file, filePrefix)).then((data) => {
            if (data.error) {
                changeFileUploadStatus(requestFileId, FILE_UPLOAD_STATUS.ERROR);
                let errMessage =
                    data?.payload?.json?.message ||
                    this.props.t(keys.GENERAL_SOMETHING_WENT_WRONG);
                this.setState({
                    selectedFile: null,
                    loaded: 0,
                    errors: errMessage,
                });
                dispatch(
                    changeFileUploadStatus(
                        requestFileId,
                        FILE_UPLOAD_STATUS.ERROR
                    )
                );
                if (this.props.setPicErr) this.props.setPicErr(errMessage);
                return;
            }
            this.props.successUploadHandler &&
                this.props.successUploadHandler(
                    requestFileId === BOOTH_POSTER_REQUEST_KEY
                        ? {
                              ...data?.payload,
                              fileName: file.name,
                          }
                        : data?.payload
                );
            requestFileId === BOOTH_POSTER_REQUEST_KEY &&
                this.props.getFileInfo(file);
        });
        event.target.value = null;
    };

    render() {
        const { fileURL: uplaodFileUrl, existingImg } = this.props;
        const {
            loaded,
            errors,
            fileName,
            uploadSize,
            removeImg,
            showImg,
            fileURL,
            errorMsg,
            customError,
            hasFilter,
            isSVG,
            removeText,
            deleteIcon,
        } = this.state;
        const Logo = () => (
            <SVG src={uplaodFileUrl || fileURL} style={stylePreviewObject} />
        );
        const renderImagePreview = () => {
            const {
                showImageSize,
                imageType,
                defaultImageUploaded,
                isCustomUploader,
                showCustomIcons = false,
                getCustomIcons = noop(),
            } = this.props;
            return (
                <>
                    {removeImg && showImageSize && !showCustomIcons && (
                        <div className='upload-details'>
                            <span>
                                {fileName}, {uploadSize}
                            </span>
                            <span
                                className={`delete-upload ${
                                    deleteIcon && 'delete-upload-icon'
                                }`}
                                onClick={this.onRemoveHandler}
                            >
                                {deleteIcon ? (
                                    <SVGIcon
                                        icon='delete'
                                        width='14px'
                                        height='14px'
                                        fill='semantic.1'
                                    />
                                ) : (
                                    removeText
                                )}
                            </span>
                        </div>
                    )}

                    {((removeImg && !showImageSize) || !defaultImageUploaded) &&
                        !showCustomIcons &&
                        (isCustomUploader ? (
                            <div className='custom-uploader-wrapper'>
                                <div
                                    className='remove-logo'
                                    onClick={this.onRemoveHandler}
                                >
                                    <Typography
                                        color={'lighting.6'}
                                        variant={'subtext2'}
                                    >
                                        Remove
                                    </Typography>
                                </div>
                                <div className='change-img'>
                                    <Typography
                                        color={'ambience.24'}
                                        variant={'subtext2'}
                                    >
                                        Change
                                    </Typography>
                                </div>
                            </div>
                        ) : (
                            <div
                                className='remove-logo'
                                onClick={this.onRemoveHandler}
                            >
                                <i className='fa fa-trash'></i>
                                <label>Remove {imageType}</label>
                            </div>
                        ))}
                    {!this.props.hidePreview && (
                        <div
                            className={
                                showImg
                                    ? 'image-preview'
                                    : 'image-preview d-none'
                            }
                        >
                            {hasFilter && isSVG ? (
                                Logo()
                            ) : (
                                <img
                                    src={
                                        uplaodFileUrl || fileURL || existingImg
                                    }
                                    alt='imagePreview'
                                    style={stylePreviewObject}
                                />
                            )}
                            {!showCustomIcons && (
                                <div class='edit-upload'>
                                    <SVGIcon
                                        icon='edit'
                                        width='16px'
                                        height='16px'
                                        fill='white'
                                        className='d-none'
                                    />
                                </div>
                            )}
                            {showCustomIcons &&
                                getCustomIcons({
                                    onRemoveHandler: this.onRemoveHandler,
                                })}
                        </div>
                    )}
                </>
            );
        };
        return (
            <div>
                <input
                    type='file'
                    name='file'
                    title=''
                    onChange={this.onChangeHandler}
                    accept={this.state.format.join(', ')}
                />
                {loaded === 1 &&
                    (uplaodFileUrl || fileURL || existingImg) &&
                    renderImagePreview()}
                {!customError ? (
                    errorMsg ? (
                        <p className='m-0 pb-1 text-center text-danger'>
                            {errors !== null && errorMsg}
                        </p>
                    ) : (
                        <p className='m-0 pb-1 text-center text-danger'>
                            {errors !== null && errors}
                        </p>
                    )
                ) : null}
            </div>
        );
    }
}
const mapStateToProps = (store, props) => {
    const createAirmeetMasterImageUrl =
        store.FileUploader.files[props.requestFileId];
    const fileURL = createAirmeetMasterImageUrl
        ? createAirmeetMasterImageUrl.url
        : props.imageUrl
        ? props.imageUrl
        : '';
    const isImageUploaded = store.FileUploader.files[props.requestFileId] || '';
    return { ...props, fileURL, isImageUploaded };
};
export default connect(mapStateToProps)(FileUploader);
